<template>
  <div class="coupon-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t("sale.coupon.title1") }}</span>
        <!-- <list-search @listSearchEvn="listSearchEvn"/> -->
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'createCoupon' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          :currentPage="currentPage"
          :pageSize="params.limit"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <el-dialog
      :title="$t('sale.coupon.details')"
      :visible.sync="centerDialogVisible"
      width="40%"
      center
    >
      <el-form :model="couponItem" ref="form" label-width="140px">
        <el-form-item :label="$t('sale.coupon.activity')" prop="name">
          {{ couponItem.name }}
        </el-form-item>
        <el-form-item :label="$t('sale.coupon.type')" prop="type">
          <span v-if="couponItem.couponType === 1">{{
            $t("sale.coupon.discountCoupon")
          }}</span>
          <span v-if="couponItem.couponType === 0">{{
            $t("sale.coupon.discodeductionuntCoupon")
          }}</span>
        </el-form-item>
        <el-form-item :label="$t('sale.coupon.publishAt')" prop="publishAt">
          {{ couponItem.publishAt | filterDate }}
        </el-form-item>
        <el-form-item
          :label="$t('sale.coupon.minus')"
          prop="minus"
          v-if="couponItem.couponType === 0"
        >
          <div>{{ couponItem.minus / 100 }} {{ $t("sale.coupon.yuan") }}</div>
        </el-form-item>
        <el-form-item
          :label="$t('sale.coupon.discount')"
          prop="discount"
          v-if="couponItem.couponType === 1"
        >
          <div>{{ couponItem.discount * 10 }} {{ $t("sale.coupon.zhe") }}</div>
        </el-form-item>
        <el-form-item :label="$t('sale.coupon.num')" prop="num">{{
          couponItem.num
        }}</el-form-item>
        <el-form-item :label="$t('sale.coupon.useRange')" prop="useRange">
          <span v-if="couponItem.useRange === 0">{{
            $t("sale.coupon.all")
          }}</span>
          <span v-if="couponItem.useRange === 1">{{
            $t("sale.coupon.monthly")
          }}</span>
          <span v-if="couponItem.useRange === 2">{{
            $t("sale.coupon.quarter")
          }}</span>
          <span v-if="couponItem.useRange === 3">{{
            $t("sale.coupon.year")
          }}</span>
        </el-form-item>
        <el-form-item :label="$t('sale.coupon.valid')">
          <span>{{ couponItem.startAt | filterDate }}</span>
          <span style="font-weight: bold;margin: 0 10px;">--</span>
          <span>{{ couponItem.endAt | filterDate }}</span>
        </el-form-item>
        <el-form-item :label="$t('sale.coupon.userList')" prop="userList">
          <el-input
            type="textarea"
            :rows="5"
            resize="none"
            v-model="couponItem.userList"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: {
    AppTable,
    Pagination,
    ListSearch
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: this.$t("sale.coupon.activity")
        },
        {
          prop: "publishAt",
          label: this.$t("sale.coupon.publishAt")
        },
        {
          prop: "endAt",
          label: this.$t("sale.coupon.endAt")
        },
        {
          prop: "num",
          label: this.$t("sale.coupon.num")
        },
        {
          prop: "couponType",
          label: this.$t("sale.coupon.type")
        },
        {
          prop: "minus",
          label: this.$t("sale.coupon.minus")
        },
        {
          prop: "gets",
          label: this.$t("sale.coupon.gets")
        },
        {
          prop: "discount",
          label: this.$t("sale.coupon.discount")
        },
        {
          prop: "handle",
          label: this.$t("org.manage"),
          width: 200,
          btn: [
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 20, offset: 0 },
      centerDialogVisible: false,
      couponItem: {}
    };
  },
  methods: {
    getList() {
      this.$http
        .getCoupons(this.params)
        .then(res => {
          // this.total = res.data.count
          this.tableData = res;
        })
        .catch(() => {});
    },

    deleteCoupons(id) {
      this.$http
        .deleteCoupons(id)
        .then(res => {
          this.getList();
          this.$message({
            type: "success",
            message: this.$t("alertMsg.delSuccess")
          });
        })
        .catch(() => {});
    },
    edit(data) {
      this.$router.push({ name: "createCoupon", query: { id: data.row._id } });
    },
    del(data) {
      this.deleteCoupons(data.row._id);
    },
    toDetails(data) {
      this.couponItem = data.row;
      this.centerDialogVisible = true;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.coupon-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
}
</style>
